import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Trash2, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { Page } from "@/components/Shell";
import { ConfirmAction } from "@/components/ConfirmAction";
import { api, errMsg, fmtTime } from "@/lib/api";

export default function Conversations() {
  const [items, setItems] = useState(null);
  const navigate = useNavigate();
  const load = () => api.get("/conversations").then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { const { data } = await api.post("/conversations", {}); navigate(`/c/${data.id}`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (id) => {
    try { await api.delete(`/conversations/${id}`); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <Page eyebrow="Archive" title="Conversations" intro="Every thread you've opened with Feerd, across web, voice and WhatsApp."
      action={<button onClick={create} data-testid="new-conversation-button" className="px-6 py-3 rounded-full bg-[#C0C0C0] text-[#0A0A0A] text-xs tracking-[0.2em] uppercase hover:bg-[#F8F4E6] transition-colors">New conversation</button>}>
      {items && items.length === 0 && <p className="font-display italic text-2xl text-[#5f5f5f]" data-testid="conversations-empty">Nothing here yet.</p>}
      <ul className="border-t border-[#1c1c1c]" data-testid="conversation-list">
        {(items || []).map((c, i) => (
          <li key={c.id} className="group flex items-center gap-6 border-b border-[#1c1c1c] py-6 hover:bg-[#0f0f0f] transition-colors duration-300 px-2">
            <span className="font-display text-[#3a3a3a] text-2xl w-10">{String(i + 1).padStart(2, "0")}</span>
            <Link to={`/c/${c.id}`} className="flex-1 min-w-0" data-testid={`conversation-link-${c.id}`}>
              <p className="font-display text-xl md:text-2xl text-ivory truncate group-hover:text-[#D8BFD8] transition-colors">{c.title}</p>
              <p className="mt-1 text-xs text-[#5f5f5f] tracking-wide">{c.channel} · {fmtTime(c.updated_at)}</p>
            </Link>
            <ArrowUpRight className="h-4 w-4 text-[#3a3a3a] group-hover:text-[#C0C0C0] transition-colors hidden md:block" strokeWidth={1.5} />
            <ConfirmAction title="Delete this conversation?" description="Its messages will be removed and any running tasks cancelled." onConfirm={() => remove(c.id)} testId={`conversation-delete-dialog-${c.id}`}
              trigger={<button data-testid={`conversation-delete-${c.id}`} aria-label="Delete conversation" className="text-[#3a3a3a] hover:text-[#e2a6a6] transition-colors"><Trash2 className="h-4 w-4" strokeWidth={1.5} /></button>} />
          </li>
        ))}
      </ul>
    </Page>
  );
}
